import { render } from "./SocialNetworksForm.vue?vue&type=template&id=854f83a2"
import script from "./SocialNetworksForm.vue?vue&type=script&lang=js"
export * from "./SocialNetworksForm.vue?vue&type=script&lang=js"
script.render = render

export default script